"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableRow = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var AcTableContext_1 = require("./AcTableContext");
var AcTableRow_module_scss_1 = __importDefault(require("./AcTableRow.module.scss"));
var AcTableRowInner = function (props, ref) {
    var _a, _b;
    var _c, _d, _e, _f, _g, _h;
    var onRowClick = props.onRowClick, onRowDoubleClick = props.onRowDoubleClick, onRowExpand = props.onRowExpand, onRowCollapse = props.onRowCollapse, functionContext = props.functionContext, data = props.data, activeData = props.activeData, highlight = props.highlight, rowClassName = props.rowClassName, rowGap = props.rowGap, expandRowWithoutTrTag = props.expandRowWithoutTrTag, isExpandableRow = props.isExpandableRow, children = props.children;
    /// Created for parent to use.
    react_1.useImperativeHandle(ref, function () { return ({
        getRowHeight: function () {
            var _a;
            return (_a = trEl.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        },
    }); });
    var useAcTableMethods = AcTableContext_1.useAcTableContext();
    var isExpandAll = (useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.isExpandAll) || false;
    // @ts-ignore
    var dataId = (data === null || data === void 0 ? void 0 : data.id) || '';
    var trEl = react_1.useRef(null);
    var _j = __read(react_1.useState(false), 2), expandRow = _j[0], setExpandRow = _j[1];
    react_1.useEffect(function () {
        var _a;
        if (!isExpandableRow) {
            setExpandRow(false);
            (_a = useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.removeExpandedDataId) === null || _a === void 0 ? void 0 : _a.call(useAcTableMethods, dataId);
        }
    }, [isExpandableRow]);
    react_1.useEffect(function () {
        setExpandRow(isExpandAll);
    }, [isExpandAll]);
    var buildHighlight = function () {
        if (!highlight) {
            return undefined;
        }
        var value;
        if (typeof highlight === 'function') {
            value = highlight(data || {}, functionContext || {});
        }
        else {
            value = highlight;
        }
        if (value === true)
            return 'default';
        if (value === false || value === undefined || !['default', 'warning'].includes(value))
            return undefined;
        return value;
    };
    var traverseToTr = function (el, elements) {
        if (el !== trEl.current) {
            if (el === null || el === void 0 ? void 0 : el.parentElement) {
                return elements.concat(el, traverseToTr(el.parentElement, elements));
            }
        }
        return elements;
    };
    var filterClickRow = function (elements) {
        var filterClassNames = ['dropdown', 'ac-table--no-row-click', 'fa-ellipsis-v-alt']; // TODO use specific class instead of fa-ellipsis-v-alt
        var filterElement = elements.find(function (el) {
            var filterClassName = filterClassNames.find(function (name) { return el.className.includes(name); });
            return !!filterClassName;
        });
        return !!filterElement;
    };
    var hasExpandRow = function (elements) {
        var filterClassNames = ['ac-table--expand-row'];
        var filterElement = elements.find(function (el) {
            var filterClassName = filterClassNames.find(function (name) { return el.className.includes(name); });
            return !!filterClassName;
        });
        return !!filterElement;
    };
    var onClickRow = function (e) {
        var _a, _b;
        if (onRowExpand) {
            var elements = traverseToTr(e.target, []);
            if (hasExpandRow(elements)) {
                if (expandRow) {
                    (_a = trEl === null || trEl === void 0 ? void 0 : trEl.current) === null || _a === void 0 ? void 0 : _a.classList.remove('row-expanded');
                    useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.removeExpandedDataId(dataId);
                }
                else {
                    (_b = trEl === null || trEl === void 0 ? void 0 : trEl.current) === null || _b === void 0 ? void 0 : _b.classList.add('row-expanded');
                    useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.addExpandedDataId(dataId);
                }
                setExpandRow(!expandRow);
                if (expandRow) {
                    onRowCollapse === null || onRowCollapse === void 0 ? void 0 : onRowCollapse(data, functionContext);
                }
                return;
            }
        }
        if (onRowClick) {
            var elements = traverseToTr(e.target, []);
            onRowClick(data, functionContext, filterClickRow(elements));
        }
    };
    var onDoubleClickRow = function (e) {
        if (onRowDoubleClick) {
            var elements = traverseToTr(e.target, []);
            onRowDoubleClick(data, functionContext, filterClickRow(elements));
        }
    };
    // TODO refactor style.inCharge to use highlight callback
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", { id: "ac-table-row-" + ((_c = data) === null || _c === void 0 ? void 0 : _c.id), ref: trEl, className: clsx_1.default(rowClassName, (_a = {
                    'table-active': ((_d = data) === null || _d === void 0 ? void 0 : _d.id) === ((_e = activeData) === null || _e === void 0 ? void 0 : _e.id),
                    'font-weight-bold': buildHighlight() === 'default'
                },
                _a[AcTableRow_module_scss_1.default.inCharge] = data.inCharge === 'MINE' &&
                    data.isDraftDocument !== true &&
                    data.isReceivedDocument === true,
                _a)), onClick: onClickRow, onDoubleClick: onDoubleClickRow }, children),
        isExpandableRow && expandRow && !!onRowExpand && !expandRowWithoutTrTag && (react_1.default.createElement("tr", { id: "ac-table-row-" + ((_f = data) === null || _f === void 0 ? void 0 : _f.id) + "-expand", className: clsx_1.default((_b = {
                    'table-active': ((_g = data) === null || _g === void 0 ? void 0 : _g.id) === ((_h = activeData) === null || _h === void 0 ? void 0 : _h.id),
                    'font-weight-bold': buildHighlight() === 'default'
                },
                _b[AcTableRow_module_scss_1.default.inCharge] = data.inCharge === 'MINE' &&
                    data.isDraftDocument !== true &&
                    data.isReceivedDocument === true,
                _b)), onClick: onClickRow, onDoubleClick: onDoubleClickRow }, onRowExpand(data, functionContext))),
        isExpandableRow && expandRow && !!onRowExpand && expandRowWithoutTrTag && (react_1.default.createElement(react_1.default.Fragment, null, onRowExpand(data, functionContext))),
        rowGap && react_1.default.createElement(react_1.default.Fragment, null, rowGap)));
};
// Generic types are not accepted by forwardRef, wrap in inner
// explictly set type because the generic types are <unknown, unknown> otherwise
exports.AcTableRow = react_1.default.forwardRef(AcTableRowInner);
AcTableRowInner.displayName = 'AcTableRow';
//# sourceMappingURL=AcTableRow.js.map